import { createSelector } from '@reduxjs/toolkit';
import { selectSuperSimplifierDetails } from '../../store/selectors';

export const selectTransactions = createSelector(selectSuperSimplifierDetails, (superSimplifierDetails) => superSimplifierDetails.transactions.transactions);
export const selectTransactionsParameters = createSelector(
  selectSuperSimplifierDetails,
  (superSimplifierDetails) => superSimplifierDetails.transactions.parameters
);
